// ----- Viewport (design coords) -----
// Logical viewport. Real canvas pixel size scales separately.
export const DESIGN_WIDTH = 844;
export const DESIGN_HEIGHT = 390;
export const ASPECT_RATIO = DESIGN_WIDTH / DESIGN_HEIGHT;

// Safe insets for notch/home indicator. Phase 1 - all zeros, used in Phase 4.
export const SAFE_INSETS = { top: 0, right: 0, bottom: 0, left: 0 } as const;

// ----- Battle structure -----
// 10 rounds: enough for a KO at current damage/dodge numbers (sim: ~95% of
// skill-less mirror battles end in a knockout before the cap)
export const ROUNDS_PER_BATTLE = 10;

// ----- Render pacing -----
// Multiplies all animation/pause durations. 1.0 = baseline, 1.5 = 50% slower.
export const BATTLE_PACE_SCALE = 4.5;

// ----- Audio -----
// Master SFX volume (0..1). Applied per-clip in playSfx helper. Tune down if
// raw audio files are mastered too hot.
export const SFX_VOLUME = 0.05;

// ----- HP -----
// high base / low per-point keeps a health point worth roughly the same as a
// strength point (+5% effective HP vs +5% damage) - see src/dev/simulate.ts
export const BASE_HP = 75;
export const HP_PER_POINT = 5;

// ----- Damage / Strength -----
export const BASE_DAMAGE = 10;
export const STR_COEF = 0.05;

// ----- Dodge / Agility -----
// low base - dodge is earned by agility, not free; cap keeps agility stacking
// from making a build untouchable
export const BASE_DODGE = 0.05;
export const AGI_DODGE_COEF = 0.02;
export const DODGE_CAP = 0.5;

// ----- Skills / Luck -----
export const LUCK_COEF = 0.02;

// ----- Defaults when no skill triggers -----
// Chance of free counter-attack after a successful DODGE (no skill).
// Block has no default reduction - characters without a block-skill take full
// damage on un-dodged hits.
export const DEFAULT_DODGE_COUNTER_CHANCE = 0.3;

// ----- Default attack variants (punch / kick) -----
// A default attack (no attack-skill triggered) randomly resolves to punch or
// kick for visual + damage variety. Kick is the rarer, heavier hit.
export const KICK_CHANCE = 0.3;        // 30% kick, 70% punch
export const KICK_DAMAGE_MULT = 1.5;   // kick deals 1.5x the punch (baseline) damage
// Kick is heavy enough to toss the defender up (pain-air). Punch never does.
// Skill launches are per-skill (AttackSkill.launches); this is the default-kick
// equivalent toggle.
export const KICK_LAUNCHES = true;
